import Typography from "@mui/material/Typography";

import { colors } from "@dotnet/telematics-design-system";

interface SettingsTypeWrapperProps {
  type?: string;
  children?: React.ReactNode;
}

const SettingsTypeWrapper = ({ type, children }: SettingsTypeWrapperProps) => {
  return type ? (
    <>
      <Typography
        variant="body3Regular"
        sx={{ color: colors.textPlaceholder, paddingTop: "16px" }}
        component="div"
      >
        {type}
      </Typography>
      {children}
    </>
  ) : null;
};

export default SettingsTypeWrapper;
